import { Box, Container } from "@chakra-ui/react";
import { Helmet } from "react-helmet-async";
import { Outlet } from "react-router-dom";

import { CelestialFooter } from "@/components/celestial/CelestialFooter";
import { NavigationBar } from "@/components/celestial/NavigationBar";

export const AppLayout = () => (
  <Box
    bg="surface"
    color="white"
    minH="100vh"
    fontFamily="body"
    overflowX="hidden"
  >
    <Helmet prioritizeSeoTags>
      <title>AstroSatvik — Premium Vedic Astrology & Gemstone Remedies</title>
      <meta name="description" content="Get personalized Vedic Astrology consultations, Kundali matching, transit insights, and authentic energized gemstone recommendations to support your spiritual growth." />
      <meta name="keywords" content="Vedic Astrology, Astrology Consultation, Kundali matching, Astro remedies, Gemstones, Planetary transits, Saturn Transit, Horoscope" />
      <meta name="apple-mobile-web-app-title" content="AstroSatvik" />
      <meta name="application-name" content="AstroSatvik" />
      <meta
        name="google-site-verification"
        content="5ioq7L9iPz5sEKWlCFQq5QFJTzfHuKQdBv3H-5_eIIQ"
      />
      {/* Global Open Graph & Twitter Social Card Fallbacks */}
      <meta property="og:site_name" content="AstroSatvik" />
      <meta property="og:type" content="website" />
      <meta property="og:title" content="AstroSatvik — Premium Vedic Astrology & Gemstone Remedies" />
      <meta property="og:description" content="Get personalized Vedic Astrology consultations, Kundali matching, transit insights, and authentic energized gemstone recommendations." />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content="AstroSatvik — Premium Vedic Astrology & Gemstone Remedies" />
      <meta name="twitter:description" content="Get personalized Vedic Astrology consultations, Kundali matching, transit insights, and authentic energized gemstone recommendations." />
    </Helmet>
    <NavigationBar />

    <Container maxW="container.xl" pt="100px" pb="120px">
      <Outlet />
    </Container>
    <CelestialFooter />
  </Box>
);
